import React from "react";
import _ from "lodash";
import { useGetFavoritesQuery } from "@api/apiV6";
import { useTranslation } from "react-i18next";
import { Div } from "@components/Generics.react";
import "@styles/components.scss";
import ArticleCard from "@components/ArticleCard.react";

export default function FavoriteArticles(props) {
    const { data: favorites, isSuccess } = useGetFavoritesQuery();
    const { t } = useTranslation("common");

    // ========================= Render Function =================================
    return (
        <Div nopad fullht>
            <Div big padTop gutter bold uppercase>
                {t("article.favorites")}
            </Div>
            {isSuccess && favorites.favorites.length > 0 && (
                <Div autoOverflow padBottom ht="calc(100% - 45px)">
                    {_.map(favorites.favorites, (article) => {
                        return (
                            <ArticleCard
                                key={`article-right-${article?._id}`}
                                article={article}
                                feedStyle
                            />
                        );
                    })}
                </Div>
            )}
            {isSuccess && favorites.favorites.length === 0 && (
                <Div autoOverflow padBottom ht="calc(100% - 45px)" flex>
                    <Div large superpad center-align>
                        {t("article.favoritesHelp")}
                    </Div>
                </Div>
            )}
        </Div>
    );
}
